import { computed, onBeforeUnmount, ref, type Ref } from 'vue'

// Seconds left until an ISO time, ticking once a second.
export const useCountdown = (target: Ref<string | null | undefined>) => {
  const now = ref(Date.now())
  const timer = window.setInterval(() => (now.value = Date.now()), 250)
  onBeforeUnmount(() => window.clearInterval(timer))

  const secondsLeft = computed(() => {
    if (!target.value) return 0
    return Math.max(
      0,
      Math.ceil((new Date(target.value).getTime() - now.value) / 1000),
    )
  })

  const label = computed(() => {
    const minutes = Math.floor(secondsLeft.value / 60)
    const seconds = secondsLeft.value % 60
    return `${minutes}:${String(seconds).padStart(2, '0')}`
  })

  return { secondsLeft, label, now }
}
